<template>
  <div class="appointAddDiv">
    <van-collapse v-model="activeNames" accordion @change="changeCollapse">
      <van-collapse-item
        :name="String(index)"
        v-for="(item, index) in appointArr"
        :key="index"
        :id="'collapse' + index"
      >
        <template #title>
          <div class="title" v-if="item.msg">
            <div class="title-left-err">
              {{ item.license_plate }}
            </div>
            <span class="colorPink">{{ item.company_name }}</span>
          </div>
          <div class="title" v-else>
            <div class="title-left">
              {{ item.license_plate }}
            </div>
            <span>{{ item.company_name }}</span>
          </div>
        </template>
        <template #default>
          <div>
            <div style="padding: 12px 16px 2px;">
              <div class="top-cont-text">
                <div class="left">选择厂区：</div>
                <div class="right">
                  {{ recentObj.company_name }}
                </div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">运输单位：</div>
                <div class="right">
                  {{ recentObj.info.unit }}
                </div>
              </div>
              <div class="top-cont-text">
                <div class="left">选择业务：</div>
                <div class="right" v-if="recentObj.business">
                  {{ recentObj.business.name }}
                </div>
              </div>
              <div class="top-cont-text">
                <div class="left" v-if="recentObj.business">
                  {{
                    recentObj.business.type === 1
                      ? "涉及产品线："
                      : "涉及业务子类："
                  }}
                </div>
                <div class="right" v-if="recentObj.business">
                  <div
                    v-for="(item, index) in recentObj.business.sub_business"
                    :key="index"
                  >
                    {{ item.name }}
                    <span
                      v-if="
                        index !== recentObj.business.sub_business.length - 1
                      "
                      >、
                    </span>
                  </div>
                </div>
              </div>
              <div class="top-cont-text">
                <div class="left">预约时间：</div>
                <div class="right" v-if="recentObj.booking_time">
                  {{ formatBookingTime(recentObj.booking_day) }}
                  {{ recentObj.booking_time.begin_time }}-{{
                    recentObj.booking_time.end_time
                  }}
                </div>
              </div>
              <div class="top-cont-text errTip" v-if="item.msg">
                <div>{{ item.msg }}</div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">车牌号：</div>
                <div class="right">
                  {{ recentObj.info.license_plate || "--" }}
                </div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">车辆类型：</div>
                <div class="right">
                  {{ vehicleColumns[recentObj.info.vehicle_type - 1] }}
                </div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">司机姓名：</div>
                <div class="right">
                  {{ recentObj.info.name || "--" }}
                </div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">司机身份证：</div>
                <div class="right">
                  {{ recentObj.info.id_card || "--" }}
                </div>
              </div>
              <div class="top-cont-text" v-if="recentObj.info">
                <div class="left">司机手机号：</div>
                <div class="right">
                  {{ recentObj.info.contact || "--" }}
                </div>
              </div>
              <div class="top-cont-text">
                <div class="left">备注：</div>
                <div class="right">
                  {{ recentObj.note || "--" }}
                </div>
              </div>
            </div>

            <div class="mid-cont">
              <div style="margin: 4px 0px 14px;">
                司机身份证正反面照片：
              </div>
              <div style="display: flex;">
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[0]"
                    @click="preview_img(previewFileList, 0)"
                  />
                </div>
                <span style="width: 10px;display: inline-block;"></span>
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[1]"
                    @click="preview_img(previewFileList, 1)"
                  />
                </div>
              </div>
            </div>

            <div class="mid-cont">
              <div style="margin: 4px 0px 14px;">驾驶证主页和副页照片：</div>
              <div style="display: flex;">
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[2]"
                    @click="preview_img(previewFileList, 2)"
                  />
                </div>
                <span style="width: 10px;display: inline-block;"></span>
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[3]"
                    @click="preview_img(previewFileList, 3)"
                  />
                </div>
              </div>
            </div>

            <div class="mid-cont">
              <div style="margin: 4px 0px 14px;">行驶证主页和副页照片：</div>
              <div style="display: flex;">
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[4]"
                    @click="preview_img(previewFileList, 4)"
                  />
                </div>
                <span style="width: 10px;display: inline-block;"></span>
                <div style="flex: 1;">
                  <img
                    class="card-img"
                    :src="previewFileList[5]"
                    @click="preview_img(previewFileList, 5)"
                  />
                </div>
              </div>
            </div>

            <div
              style="text-align: center;border-top: 1px solid #f3f3f3;padding: 14px 0px;"
            >
              <van-button
                color="#00C8D2"
                style="padding: 11px 42px;height: 35px;font-size: 18px;"
                @click="deleteAppoint(item)"
                >删 除</van-button
              >
            </div>
          </div>
        </template>
        <template #right-icon>
          <div
            class="rightIcon"
            @click="
              $router.push({
                path: '/rhwxEmergeAppointModify/0',
                query: {
                  type: 'edit',
                  pageType: 'add',
                  info_id: item.info_id,
                  id: item.id,
                  time1: time1,
                  time2: time2,
                  keyword: keyword
                }
              })
            "
          >
            <van-icon name="edit" color="#9b9b9b" style="line-height: 26px;" />
          </div>
        </template>
      </van-collapse-item>
    </van-collapse>
    <div
      class="addBtn"
      @click="
        $router.push({
          path: '/rhwxEmergeAppointModify/0',
          query: {
            type: 'add',
            pageType: 'add',
            time1: time1,
            time2: time2,
            keyword: keyword
          }
        })
      "
    >
      <div>
        <van-icon
          name="add-o"
          size="20"
          style="vertical-align: sub;margin-right: 8.7px;"
        />
      </div>
      <div>{{ appointArr.length === 0 ? "添加预约" : "继续添加" }}</div>
    </div>
    <!-- <Empty v-if="appointArr.length == 0" style="margin-top: 40px;"></Empty> -->
    <div style="height: 170px;background-color: #f4f5f6;"></div>
    <div class="footer-cont2">
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="confirmShow = true"
        :disabled="appointArr.length === 0"
        >提交预约</van-button
      >
    </div>

    <van-dialog
      v-model="deleteShow"
      title="警告"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk" v-if="recentObj.info">
          您确认要删除“
          <span class="colorGreenLight">
            {{ recentObj.info.license_plate }}
          </span>
          ”的预约记录吗？
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="confirmDelete">
            <van-button block class="dialogBtnConfirm">确认删除</van-button>
          </div>
          <div style="flex: 1;" @click="deleteShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
        </div>
      </template>
    </van-dialog>

    <van-dialog
      v-model="confirmShow"
      title="注意"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          您确认要提交预约信息吗？<span class="colorPink"
            >请核实并确保所有信息无误！</span
          >
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="confirmShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1;" @click="saveAppoint">
            <van-button block class="dialogBtnConfirm">确认提交</van-button>
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { ImagePreview } from "vant";
// import Empty from "@/components/tips/Empty.vue";
export default {
  data() {
    return {
      activeNames: "",
      deleteShow: false,
      appointArr: [],
      tag: true,
      rowDataObj: {},
      recentObj: {},
      vehicleColumns: ["平板车", "货柜车", "槽罐车", "其他", "高栏车"],
      previewFileList: [],
      confirmShow: false
    };
  },
  mounted() {
    this.getList();
    // localStorage.removeItem("appointEmergeModify");
  },
  // components: {
  //   Empty
  // },
  methods: {
    preview_img(images, index) {
      ImagePreview({
        images: images, // 图片数组
        showIndex: true,
        loop: true,
        startPosition: index
        // closeable: true
      });
    },

    // 删除预约信息
    deleteAppoint() {
      this.deleteShow = true;
    },

    // 确认删除预约信息
    confirmDelete() {
      this.deleteShow = false;
      this.$common
        .http({
          url: "/api/queue/emergency/delete_booking",
          data: {
            id: this.recentObj.id
          }
        })
        .then(() => {
          this.getList();
          this.activeNames = ["0"];
          this.activeNames = "";
          setTimeout(() => {
            this.$common.mbToastSuccess("删除成功");
          }, 1000);
        });
    },

    // 提交预约
    saveAppoint() {
      this.$common
        .http({
          url: "/api/queue/emergency/save_booking",
          data: {}
        })
        .then(res => {
          // this.getList();
          if (res.data.data.state === 0) {
            setTimeout(() => {
              this.$common.mbToastSuccess("提交成功");
              setTimeout(() => {
                this.$router.push({
                  path: "/rhwxEmergeAppointSuccess",
                  query: {
                    time1: this.time1,
                    time2: this.time2,
                    keyword: this.keyword
                  }
                });
              }, 1000);
            }, 1000);
          } else {
            console.log(res.data.data.err_msg);
            let obj = res.data.data.err_msg;
            // Toast({
            //   message: `提交失败，已标记出${obj.length}处错误，请处理后再尝试提交！`,
            //   className: "toastEDE"
            // });
            this.$common.mbToastFail(
              `提交失败，已标记出${obj.length}处错误，请处理后再尝试提交！`
            );
            for (let i = 0; i < this.rowDataObj.length; i++) {
              for (let j = 0; j < obj.length; j++) {
                if (this.rowDataObj[i].id === obj[j].booking_id) {
                  this.rowDataObj[i].msg = obj[j].msg;
                }
              }
            }
            this.activeNames = ["0"];
            this.activeNames = "";
          }
        });
    },

    // 切换折叠面板
    changeCollapse(activeNames) {
      if (activeNames) {
        this.$common
          .http({
            url: "/api/queue/emergency/get_booking_detail",
            data: {
              info_id: this.appointArr[activeNames].info_id
            }
          })
          .then(res => {
            console.log(res.data.data);
            this.previewFileList = [];
            this.recentObj = res.data.data;
            this.recentObj.file.forEach(item => {
              let index = "";
              if (Number(item.type) === 0) {
                index = 0;
              } else if (Number(item.type) === 1) {
                index = 1;
              } else if (Number(item.type) === 4) {
                index = 2;
              } else if (Number(item.type) === 5) {
                index = 3;
              } else if (Number(item.type) === 2) {
                index = 4;
              } else if (Number(item.type) === 3) {
                index = 5;
              }
              item.index = index;
              this.previewFileList.splice(item.index, 0, item.real_path);
              // this.previewFileList.push(item.real_path);
            });
          });
      }
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 获取列表
    async getList() {
      await this.$common
        .http({
          url: "/api/queue/emergency/query_draft_booking"
        })
        .then(res => {
          console.log(res);
          this.appointArr = [];
          this.rowDataObj = res.data.data;
          this.rowDataObj.forEach(item => {
            this.appointArr.push(item);
          });
          // this.changeCollapse("0");
        });
    }
  },
  created() {},
  computed: {
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointAddDiv {
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #f4f5f6;
  .rightIcon {
    font-size: 20px;
    padding: 17px 16px 12px 0px;
  }
  .title {
    padding: 12px 0px 12px 16px;
    font-size: 16px;
  }
  .bg3ee {
    background: #e5f3ee;
  }
  .bgfff {
    background: #fff;
  }
  .bg8de {
    background: #cde8de !important;
  }
  .bgbef {
    background: #fdebef !important;
  }
  // .colorPink {
  //   color: #ec3f67 !important;
  // }
  .title-left {
    display: inline-block;
    background: #e5f3ee;
    padding: 5px 7px;
    color: #008b5e;
    margin-right: 14px;
    border-radius: 2px;
  }
  .title-left-err {
    display: inline-block;
    background: #fdebef;
    padding: 1px 10px;
    color: #ec3f67;
    margin-right: 14px;
  }
  .top-cont-text {
    padding: 0px 0px 14px;
    background: #fff;
    font-size: 16px;
    display: flex;
    .left {
      display: inline-block;
      // width: calc(31vw - 15px);
      text-align: right;
      margin-right: 15px;
      vertical-align: top;
      color: #b2b2b2;
      flex: 1;
    }
    .right {
      display: inline-block;
      /* width: calc(69vw - 32px); */
      vertical-align: top;
      word-break: break-all;
      color: #000;
      flex: 1.7;
    }
  }
  .mid-cont {
    background: #fff;
    padding: 16px;
    font-size: 18px;
    color: #000;
    border-top: 1px solid #f3f3f3;
  }
  .card-img {
    object-fit: cover;
    // width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    width: 100%;
  }
  .errTip {
    justify-content: center;
    font-size: 13px;
    margin-top: -10px;
    color: #ec3f67;
  }
  .addBtn {
    height: 58px;
    text-align: center;
    line-height: 58px;
    background: #fff;
    font-size: 16px;
    color: #008b5e;
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="less">
.appointAddDiv {
  .van-collapse-item {
    margin-bottom: 10px;
  }
  .van-cell--clickable {
    // padding: 14px 16px;
    padding: 0px;
  }
  .van-collapse-item__content {
    padding: 0px;
  }
  .van-dialog__header {
    opacity: 0.9;
    font-size: 17px;
    color: #000000;
    text-align: center;
  }
}
</style>
